module.exports = __webpack_public_path__ + "img/L_2S.f46cc470.png";